import { InjectionToken } from '@angular/core';

export const TOAST_CONFIGURATION = new InjectionToken<string>('TOAST_CONFIGURATION');
